const debounce = require('lodash/debounce');

function loadPopups() {
    if (!$('.customized-newsletter').length) return;

    const Config = {
        DebounceInterval: 200,
        MobileWidthBreakpoint: 768,
        MobileLandscapeHeightBreakpoint: 768,
        MobileLandscapeWidthBreakpoint: 1024,
        DefaultAnimationDuration: 400,
        NewsletterTextChangeAnimationTimeout: 11000,
        ScrollTriggerPixelThreshhold: window.innerHeight / 2,
        Desktop: {
            PopupAfterScrollTimeout: 9500,
            PopupDefaultTimeout: 29500,
            PauseAllTimeout: 10000,
            ETFsOpenTimeout: 5000,
            NewsletterOpenTimeout: 5000
        },
        Mobile: {
            PopupAfterScrollTimeout: 30000,
            PopupDefaultTimeout: 29500,
            PauseAllTimeout: 15000,
            ETFsOpenTimeout: 5000,
            NewsletterOpenTimeout: 5000
        },
        Debug: false,
        DebugParams: {
            PopupAfterScrollTimeout: 5000,
            PopupDefaultTimeout: 4000,
            PauseAllTimeout: 4000,
            ETFsOpenTimeout: 5000,
            NewsletterOpenTimeout: 10000
        },
        getState: () => JSON.parse(localStorage.getItem("ve.eu.themes.newsletterpopup")),
        setState: (key, value) => {
            let state = Config.getState();
            state = state ?? {};
            state[key] = value;
            return localStorage.setItem("ve.eu.themes.newsletterpopup", JSON.stringify(state));
        },
        Device: () => getDevice() ? "Desktop" : "Mobile",
    }

    //If in debug mode, override the device params.
    if (Config.Debug) ["Desktop", "Mobile"].forEach(x => Config[x] = Config.DebugParams);

    window.popupStatus = "init";

    //Translations -- get from the view.
    $('.customized-newsletter .form-control.Email').attr('placeholder', veDictionary.email);
    $('.customized-newsletter .form-control.FirstName').attr('placeholder', veDictionary.firstName);
    $('.customized-newsletter .form-control.LastName').attr('placeholder', veDictionary.lastName);

    //Conscent is ticked by default for newsletter popup.
    $('.customized-newsletter .FormConsent').prop('checked', true);

    //Show pop-ups on click.
    $(".customized-newsletter .discover-more-etfs").on("click", () => {
        showPopup("etfs", true); 
        window.popupStatus = "etfs-clicked"
    });
    $(".sub-sticky-btn-new").on("click", () => {
        showPopup("newsletter", true);
        window.popupStatus = "newsletter-clicked";
    });

    //On interaction (click or hover), change status so further interaction chains are ignored.
    $(".newsletter-pop-out").click(() => window.popupStatus = "newsletter-interacted");
    $(".etfs-pop-out").hover(() => window.popupStatus = "etfs-interacted");

    //hide them on cross.
    $(".pop-out-containers .dialog__close").on("click", e => {
        hideAllPopups(false);
        const Status = Config.getState();
        //if (new Date(Status?.crossedDate) > new Date(Date.now() - 1000 * 3600 * 24 * 365)) return;
        Config.setState("crossedDate", new Date());
    });

    //And here we go...
    Config.Device() == "Desktop" ? window.setTimeout(animateNewsletterText, Config.NewsletterTextChangeAnimationTimeout) : false;
    function init() {
        //See if the user has crossed it before
        const Status = Config.getState();
        if (new Date(Status?.crossedDate) > new Date(Date.now() - 1000 * 3600 * 24 * 365)) {
            window.popupStatus = "crossed-in-the-past";
            return;
        };
        watchForPopups(Config.Device());
    }

    init()

    //Get Device
    function getDevice() {
        //Returns true if Desktop
        return (
            //1. Mobile Width
            window.outerWidth > Config.MobileWidthBreakpoint && 
            //2. Mobile Landscape
            !(
                window.outerHeight < Config.MobileLandscapeHeightBreakpoint 
                && (window.outerWidth < Config.MobileLandscapeWidthBreakpoint)
                && (window.innerHeight <  window.innerWidth)
            )
        )
    }

    function showPopup(popupName, userInteraction = false) {
        var popUpClass;
        switch (popupName) {
            case "newsletter":
                popUpClass = ".newsletter-pop-out";
                break;
            case "etfs":
                popUpClass = ".etfs-pop-out"
                break;
            default:
                return false;
        }
        hideAllPopups(!userInteraction)
        window.setTimeout(() => {
            $(popUpClass).removeClass("hide");
            $(popUpClass).fadeTo(Config.DefaultAnimationDuration,1);
            if(!userInteraction) window.popupStatus = popUpClass + "-show";
        }, 50)
    }

    function hideAllPopups(automated = false) {
        $(".pop-out-containers > div").fadeTo(100, 0).addClass("hide");
        if(automated) return;
        window.popupStatus = "none";
    }

    function animateNewsletterText() {
        $(".customized-newsletter .newsletter-text").hide("slow");
        $(".customized-newsletter .more-info").show("slow");
    }

    function showNewsletterForm(isFirst = false) {
        //If this is triggered due to a first load condition, then the status show be in init. (i.e. no other user intraction with the popups have occured.)
        if(isFirst && window.popupStatus != "init") return;
        
        const Status = Config.getState();
        var openCount = Status?.openCount ?? 0; openCount++;
        Config.setState("openCount", openCount);
        
        if((!$(".etfs-pop-out").hasClass("hide")) || (!$(".newsletter-pop-out").hasClass("hide"))) return;
        showPopup("newsletter", false);
        window.setTimeout(
            x=>pauseAll(
                true, 
                showETFs, 
                Config[Config.Device()].PauseAllTimeout, true
            ), 
        Config[Config.Device()].NewsletterOpenTimeout);
    }

    function pauseAll(isFirst = false, triggerFunction, timeout, ...fnArgs) {
        if(isFirst && window.popupStatus != ".newsletter-pop-out-show") return;
        window.popupStatus = "paused-in-between-popups";
        hideAllPopups(true);
        window.setTimeout(x=>triggerFunction.call(this, ...fnArgs), timeout);
    }

    function showETFs(isFirst = false) {
        //If this is triggered due to a first load condition, then the status should be  .newsletter-pop-out-show. (i.e. no other user intraction with the popups have occured.)
        if(isFirst && window.popupStatus != "paused-in-between-popups") return;
        showPopup("etfs", false);
        window.setTimeout(x => {
            if(window.popupStatus.includes("interacted")) return;
            hideAllPopups(true);
            window.popupStatus = "complete";
        }, Config[Config.Device()].ETFsOpenTimeout);
    }
    
    function watchForPopups(device = "Desktop") {
        var onscroll = debounce( checkifscrolledbelow, Config.DebounceInterval );
        //see if the user is scrolling and then trigger newsletter (in 10s)...
        window.addEventListener("scroll", onscroll);

        //Trigger the newsletter anyway after the default timeout
        window.setTimeout(x=>showNewsletterForm(true), Config[device].PopupDefaultTimeout);

        function checkifscrolledbelow() {
            //Do nothing if the user has not scrolled below 50% of the screen;
            if(window.scrollY < Config.ScrollTriggerPixelThreshhold) return;
            console.log("Newsletter will trigger!")
            //Trigger the newsletter form in 10 seconds after the scroll 500 ms = accounting for debounce.
            window.setTimeout(x=>showNewsletterForm(true), Config[device].PopupAfterScrollTimeout);
            window.removeEventListener("scroll", onscroll);
        }

    }

}
window.addEventListener("DOMContentLoaded", () => loadPopups());
//export default loadPopups;